// extracted by mini-css-extract-plugin
module.exports = {"w70045b":"w70045b"};